// extracted by mini-css-extract-plugin
module.exports = {"divider":"AppNavigation_divider__24T7y","nav":"AppNavigation_nav__1HXZz","pointer":"AppNavigation_pointer__D_VF0"};